import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  projects: [],
  totalProjects: 0,
  selectAllField: false,
  selectedProjects: [],
  selectedViewProject: {},
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations,
}
